<template>
  <div>
    <div class="gamebox">
      <div class="top">
        <div class="gametitle">
          {{ $t(`lang.str_detail`) }}
        </div>
      </div>
      <!-- 莊家 -->
      <div class="public ">
        <div class="title">{{ $t(`lang.str_banker_poker`) }}</div>
        <div class="menu">
          <div class="card_msg">
            <div class="item" v-for="(item,index) in bankerpoker" :key="index">
              <img alt=""  :src="require('../../assets/card/card'+'_'+parseInt(item / 100)+'_'+(item % 100)+'.png')">
            </div>
            <div class="cover" v-if="bankerPokerType != 0">
              <img class="cover_img" alt=""
                   :src="require('../../assets/bj/' + bankerPokerType + '_' + img_lang + '.png')">
            </div>
          </div>
        </div>
        <div v-if="!Phone">
          <PokerTypeMenu
            :pokerType="bankerPokerType"
            :pokerPoint="bankerPokerPoint"
            :isSeat=false>
          </PokerTypeMenu>
        </div>
      </div>
      <div v-if="Phone" class="public ">
        <PokerTypeMenu
          :pokerType="bankerPokerType"
          :pokerPoint="bankerPokerPoint"
          :isSeat=false>
        </PokerTypeMenu>
      </div>
      <!-- 玩家 -->
      <div v-for="(seat,index) in seatlist" :key="index">
        <div class="public ">
          <div class="title"> {{ $t(`lang.str_player_poker`) + "(" + (seat.SeatId + 1) + ")" }}</div>
          <div class="menu">
            <div class="card_msg">
              <div class="item" v-for="(item,pindex) in seat.HandPokers" :key="pindex">
                <img alt="" :src="require('../../assets/card/card'+'_'+parseInt(item / 100)+'_'+(item % 100)+'.png')">
              </div>
              <div class="cover" v-if="seat.HandPokersType != 0">
                <img class="cover_img" alt=""
                     :src="require('../../assets/bj/' + seat.HandPokersType + '_' + img_lang + '.png')">
              </div>
            </div>
          </div>
          <div v-if="!Phone">
              <PokerTypeMenu
              :pokerType="seat.HandPokersType"
              :pokerPoint="seat.HandPokersPoint"
              :pokerDouble="seat.HandPokerDouble"
              :pokerBet="seat.HandPokerBet"
              :isSeat=true>
            </PokerTypeMenu>
          </div>
        </div>
        <div v-if="Phone" class="public">
          <PokerTypeMenu
            :pokerType="seat.HandPokersType"
            :pokerPoint="seat.HandPokersPoint"
            :pokerDouble="seat.HandPokerDouble"
            :pokerBet="seat.HandPokerBet"
            :isSeat=true>
          </PokerTypeMenu>
        </div>
        <div class="public " v-if="seat.SplitHandPokers">
          <div class="menu_sub">
            <div class="card_msg">
              <div class="item" v-for="(item,pindex) in seat.SplitHandPokers" :key="pindex">
                <img alt=""
                     :src="require('../../assets/card/card'+'_'+parseInt(item / 100)+'_'+(item % 100)+'.png')">
              </div>
              <div class="cover" v-if="seat.SplitHandPokersType != 0">
                <img class="cover_img" alt=""
                     :src="require('../../assets/bj/' + seat.SplitHandPokersType + '_' + img_lang + '.png')">
              </div>
            </div>
          </div>
          <div v-if="!Phone">
            <PokerTypeMenu
              :pokerType="seat.SplitHandPokersType"
              :pokerPoint="seat.SplitHandPokersPoint"
              :pokerDouble="seat.SplitHandPokerDouble"
              :pokerBet="seat.SplitHandPokerBet"
              :isSeat=true></PokerTypeMenu>
          </div>
        </div>
        <div class="public " v-if="seat.SplitHandPokers && Phone">
          <PokerTypeMenu
            :pokerType="seat.SplitHandPokersType"
            :pokerPoint="seat.SplitHandPokersPoint"
            :pokerDouble="seat.SplitHandPokerDouble"
            :pokerBet="seat.SplitHandPokerBet"
            :isSeat=true></PokerTypeMenu>
        </div>
      </div>
      <div class="jokerbet">
        <div style="width:100%;">
          <div class="detail">
            <div class="detail" v-for="(seat,index) in seatlist" :key="index" style="width: 100%; text-align: left;">
              <div style="width: 100%;">{{ $t(`lang.str_player_poker`) + "(" + (seat.SeatId + 1) + ")" }}</div>
              <div style="width: 100%;">{{ $t(`lang.str_bj_bx`) }}</div>
            </div>
          </div>
          <div class="detail">
            <div class="detail" v-for="(seat,index) in seatlist" :key="index" style="width: 100%; text-align: left;">
              <div style="width: 100%;">{{((seatlist[index].HandPokerBet + seatlist[index].SplitHandPokerBet) / 100).toFixed(2)}}</div>
              <div style="width: 100%;">{{(seatlist[index].InsuranceAmount / 100).toFixed(2)}}</div>
            </div>
          </div>
          <div class="detail">
            <div class="detail" v-for="(seat,index) in seatlist" :key="index" style="width: 100%; text-align: left;">
              <div style="width: 100%;">{{((seatlist[index].HandPokerWin - seatlist[index].HandPokerBet - seatlist[index].SplitHandPokerBet) / 100).toFixed(2)}}</div>
              <div style="width: 100%;">{{((seatlist[index].InsuranceWin - seatlist[index].InsuranceAmount) / 100).toFixed(2)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DescribeLayout
      :winValueTip="winValueTip"
      :winValueTotal="winValueTotal"
      :isTotalWin="isTotalWin"
      :describe_title = "describe_title"
      :describe_content="describe_content"
      :describe_message="describe_message">

    </DescribeLayout>
  </div>
</template>
<script>
import DescribeLayout from "../common/describe_layout.vue";
import PokerTypeMenu from "./game2000/poker_type_menu.vue";

export default {
  name: "Game2001",
  components: { PokerTypeMenu, DescribeLayout},
  props:{
    winValueTip:null,
    winValueTotal:null,
    isTotalWin:false,
    describe_title:null,
    describe_content:null,
    describe_message:null,
    bankerpoker: [],
    bankerPokerType: '',
    bankerPokerPoint:'',
    img_lang:'',
    seatlist: [],
    lang: '',
    Phone:false,
  },
  data()
  {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/joker/game_2001.vue